import * as jwtDecode from 'jwt-decode'
import axios from 'axios'
import { AuthMissingError } from '@/utils/errors'
import { getPersistentAuth } from '@/utils/firebase'

const state = () => ({
  accessToken: null,
  refreshToken: null,
  uid: null,
  email: null
})

const mutations = {
  setAccessToken (state, token) {
    state.accessToken = token
  },
  setRefreshToken (state, token) {
    state.refreshToken = token
  },
  setUid (state, uid) {
    state.uid = uid
  },
  setEmail (state, email) {
    state.email = email
  }
}

const getters = {
  isLogged (state) {
    return state.refreshToken !== null || state.email !== null
  }
}

const actions = {
  login ({ commit }, refreshToken) {
    try {
      const decoded = jwtDecode(refreshToken)
      commit('setUid', decoded.user_id)
    } catch (error) {
      // todo: handle error with incorrect refresh token
      console.log(error)
      return false
    }
    commit('setRefreshToken', refreshToken)
  },
  async refreshToken ({ state, commit }) {
    if (state.refreshToken === null) {
      throw new AuthMissingError('No refresh token in store')
    }
    try {
      const response = await axios.post(
        '/users/refresh/',
        {
          refresh: state.refreshToken
        },
        {
          baseURL: process.env.API_URL
        }
      )
      commit('setAccessToken', response.data.access)
    } catch (error) {
      throw new AuthMissingError('Failed to fetch token from backend')
    }
  },
  async logout ({ commit }) {
    commit('setUid', null)
    commit('setAccessToken', null)
    commit('setRefreshToken', null)
    commit('setEmail', null)
    commit('getUser', null, { root: true })
    const auth = await getPersistentAuth()
    await auth.signOut()
  }
}

export default { namespaced: true, state, getters, actions, mutations }
